module.exports = __webpack_public_path__ + "static/media/logo.71b81f48.svg";